"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var bson_1 = require("bson");
var codefile_1 = require("../pastes/codefile");
var pastefile_1 = require("../pastes/pastefile");
var Paste = /** @class */ (function () {
    function Paste(name, key) {
        this.name = name;
        this.key = key;
        this.files = [];
    }
    Paste.prototype.serialize = function () {
        var bson = new bson_1.BSON();
        return bson.serialize({
            files: this.files.map(function (f) { return f.rawObject(); }),
            version: 3
        });
    };
    Paste.prototype.json = function () {
        return JSON.stringify({
            name: this.name,
            key: this.key,
            files: this.files.map(function (f) { return f.serialize(); }),
        });
    };
    Paste.empty = function () {
        return new Paste("", "");
    };
    Paste.fromJSON = function (json) {
        var paste = Paste.empty();
        var data = JSON.parse(json);
        paste.name = data.name;
        paste.key = data.key;
        paste.files = data.files.map(function (f, i) {
            if (codefile_1.default.isReadable(f.meta.mime)) {
                return new codefile_1.default(i, f.name, f.data, f.meta.highlight);
            }
            return new pastefile_1.default(i, f.name, f.data, f.meta.mime);
        });
        return paste;
    };
    return Paste;
}());
exports.default = Paste;
